import { User } from './user';
import { Onboarding } from './onboarding';
import { plaid } from './plaid';

export default { User, Onboarding, plaid };
